import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    line-height: 20px;
  }

  .footer-text {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .main {
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-md));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-medium));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sub {
    font-size: var(--nile-type-scale-2, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-500, var(--ng-colors-text-tertiary-600));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default [styles];
